import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Box, Typography, Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import ReloadIcon from '@mui/icons-material/Cached';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleReload = () => {
            // Optionally, you can implement a method to reload the page or retry fetching data
            window.location.reload();
        };
        this.handleLogout = () => {
            localStorage.clear();
            window.location.reload();
        };
        this.handleLogging = () => {
            var _a, _b, _c;
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            fetch('https://api.rentaltide.com/api/communication/slack', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    message: `Error from ${user === null || user === void 0 ? void 0 : user.data.email} (${(_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.id}): ${(_c = (_b = this.state.error) === null || _b === void 0 ? void 0 : _b.stack) !== null && _c !== void 0 ? _c : this.state.error}`,
                    channel: '#error-spam',
                }),
            })
                .then(response => response.json())
                .then(data => console.log('Slack message sent:', data))
                .catch(error => console.error('Error sending Slack message:', error));
        };
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render shows the fallback UI.
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        // You can log the error to an error reporting service here
        console.error("Uncaught error:", error, errorInfo);
    }
    componentDidUpdate(_, prevState) {
        if (this.state.error && this.state.error !== prevState.error) {
            this.handleLogging();
        }
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100svh", textAlign: "center", p: 2, children: [_jsx(Typography, { variant: "h1", gutterBottom: true, children: "Uh-oh, we\u2019ve hit an iceberg!" }), _jsx(Typography, { variant: "body1", gutterBottom: true, children: "Looks like our boat took on some water. Don't worry, we\u2019ve got life vests. Try reloading the page and we'll steer you back on course!" }), _jsx(Button, { variant: "contained", color: "primary", onClick: this.handleReload, startIcon: _jsx(ReloadIcon, {}), children: "Set Sail Again" }), _jsx(Box, { mt: 2, children: _jsx(Button, { variant: "outlined", color: "primary", onClick: this.handleLogout, startIcon: _jsx(LogoutIcon, {}), children: "Abandon Ship (Force Reload)" }) })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
